export default "__VITE_ASSET__BVjwIGZd__"